import {isPlatformBrowser} from '@angular/common';
import {inject, Injectable, PLATFORM_ID} from '@angular/core';
import {LoginComponent} from '../login/login.component';
import {NotificationType} from '../enum/notification-type.enum';
import {CanActivate, Router} from '@angular/router';
import {AuthenticationService} from '../services/authentication.service';
import {MatDialog} from '@angular/material/dialog';
import {NotificationService} from '../notification/notification.service';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private dialog: MatDialog,
    private notificationService: NotificationService
  ) {
  }

  canActivate(): boolean {
    if (this.authService.isLoggedIn()) {
      return true;
    }


    this.router.navigate(['/']);
    this.notificationService.sendNotification(
      NotificationType.WARNING,
      'Veuillez vous connecter pour accéder à votre informations',
      'Accès refusé'
    );

    if (isPlatformBrowser(inject(PLATFORM_ID))) {
      setTimeout(() => {
        if (!this.authService.isLoggedIn()) {
          this.dialog.open(LoginComponent, {
            panelClass: 'custom-dialog',
            disableClose: false,
            autoFocus: true
          });
        }
      }, 100);
    }

    return false;
  }
}
